import React from 'react';
import { useTranslation } from 'react-i18next';
import Spacer from '../components/Spacer';

function Resources() {
  const { t } = useTranslation();

  return (
    <>
      <Spacer />
      <div className="container" style={{ minHeight: 1000 }}>
        <h1 className="display-4 text-center text-primary">{t('resources.title')}</h1>
        <p className="text-primary">-</p>
      </div>
    </>
  );
}

export default Resources;
